import ListTransactionsComponent from '@/components/transaction/ListTransactionsComponent.vue';
import { defineComponent, ref } from 'vue';
import router from '@/router';
import { useAuthStore } from '@/store/modules/auth';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { AuthTypes } from '@/types/auth';
export default defineComponent({
    name: 'HomeComponent',
    components: {
        ListTransactionsComponent,
    },
    setup() {
        const authStore = useAuthStore();
        const { isLoggedIn, currentStep: authCurrentStep, standaloneAuthFlow, } = storeToRefs(authStore);
        const transactionsStore = useTransactionsStore();
        const { showSideMenu } = storeToRefs(transactionsStore);
        const showInput = ref(false);
        const signIn = () => {
            router.push('/auth');
            authCurrentStep.value = AuthTypes.AuthSteps.AUTH_1;
            standaloneAuthFlow.value = true;
        };
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const openSideMenu = () => {
            showSideMenu.value = true;
        };
        return {
            showInput,
            signIn,
            onKeyPress,
            isLoggedIn,
            openSideMenu,
        };
    },
});
